import { type DataForParent, microFrontListener } from '@b2ag/micro-front-tools'
import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { useRouter, type RouteLocation } from 'vue-router'
import { useStore } from 'vuex'
import { PAGE_ANALYTICS_INFO } from '../page-types'
import { callbacksFromShoppingListMicroFrontIframe } from '../../contexts/shopping-list'

/* ------- MICROFRONT - MEMBERSHIP ------- */

export const membershipRoutes = [
  {
    path: '/customer/:customerNumber/menu',
    name: 'customer-menu',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => ({
      microFrontName: 'membership',
      viewName: 'menu',
      customerNumber: route.params.customerNumber,
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      showSelectedCustomer: true,
      changeSelectedCustomer: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENT_DETAILS,
    },
  },
  {
    path: '/customer/:customerNumber',
    name: 'customer-detail',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => {
      return {
        microFrontName: 'membership',
        viewName: 'details',
        customerNumber: route.params.customerNumber,
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        callbackForMessages: (data: DataForParent) => callbacksFromShoppingListMicroFrontIframe(data),
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      showSelectedCustomer: true,
      changeSelectedCustomer: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENT_DETAILS,
    },
  },
  {
    path: '/customer/:customerNumber/list',
    name: 'customer-shopping-lists',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => ({
      microFrontName: 'membership',
      viewName: `customer-shopping-lists`,
      customerNumber: route.params.customerNumber,
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        callbackForMessages: (data: DataForParent) => callbacksFromShoppingListMicroFrontIframe(data),
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      showSelectedCustomer: true,
      changeSelectedCustomer: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENT_SHOPPING_LISTS,
    },
  },
  {
    path: '/customer/:customerNumber/orders',
    name: 'customer-orders',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => {
      return {
        microFrontName: 'membership',
        viewName: 'customer-orders',
        customerNumber: route.params.customerNumber,
        salesId: useStore().getters.user.technical_sale_information.uuid,
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      showSelectedCustomer: true,
      changeSelectedCustomer: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENT_ORDERS,
    },
  },
  {
    path: '/customers/:customerNumber/analytics',
    name: 'customer-analytics',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => {
      return {
        microFrontName: 'membership',
        viewName: 'customer-analytics',
        customerNumber: route.params.customerNumber,
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      showAppHeader: !isWebViewFarmi(),
      showSelectedCustomer: !isWebViewFarmi(),
      changeSelectedCustomer: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENT_MEMBERSHIP_ANALYTICS,
    },
  },
  {
    path: '/customer/:customerNumber/associated-accounts',
    name: 'associated-accounts',
    component: () => import('@b2ag/micro-front-membership/app'),
    props: (route: RouteLocation) => ({
      microFrontName: 'membership',
      viewName: 'associated-accounts',
      customerNumber: route.params.customerNumber,
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      showSelectedCustomer: true,
      changeSelectedCustomer: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENT_ORDERS,
    },
  },
  {
    path: '/customers',
    name: 'adherents-list',
    component: () => import('@b2ag/micro-front-membership/adherents-list'),
    props: () => ({
      microFrontName: 'membership',
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        callbackForMessages: (data: DataForParent) => callbacksFromShoppingListMicroFrontIframe(data),
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      showSelectedCustomer: true,
      changeSelectedCustomer: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ADHERENTS_LIST,
    },
  },
]
